import { render } from "./UnderConstruction.vue?vue&type=template&id=35e9a840&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-35e9a840"

export default script